import React from "react";

import moment from "moment";
import { Box } from "@mui/material";

function ExpenseExcel({ expenseList }) {
  return (
    <>
      <table id="expenseListExcel">
        <tr>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            S.No
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Create Date
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Expense Date
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Emp. Name
          </th>

          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Emp. Code
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            {JSON.parse(localStorage.getItem("Templatedata")).find(
              (label) => label.actualName === "Department"
            )?.displayName || "Department"}
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
              ? "Party Details"
              : "Meeting Details"}
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Type
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Applied Amt(₹)
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Approved Amt(₹)
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Deviated Amt(₹)
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
              ? "Descriptions"
              : "Remarks"}
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Status
          </th>
          <th
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Attached Bill
          </th>
        </tr>

        {expenseList &&
          expenseList.length > 0 &&
          expenseList.map((data, index) => {
            return (
              <tr
                //hover

                sx={{
                  background:
                    data.expenseStatus == "APPROVED"
                      ? "rgb(50 164 114) !important"
                      : data.expenseStatus == "REJECTED"
                      ? "rgb(233 75 97) !important"
                      : "",
                }}
              >
                <tr></tr>
                <td align="center">
                  {data.communicationId !== null
                    ? `M  ${index + 1}`
                    : index + 1}
                </td>
                <td align="center">
                  {moment(data.createdAt).format("DD-MM-YYYY")}
                </td>
                <td align="center">
                  {moment(data.expenseDate).format("DD-MM-YYYY")}
                </td>
                <td align="center">
                  {data.userName !== null ? data.userName : "NA"}
                </td>
                <td align="center">
                  {data.userEmpCode !== null ? data.userEmpCode : "NA"}
                </td>
                <td align="center">
                  {data.departmentName !== null ? data.departmentName : "NA"}
                </td>
                <td align="center">
                  {data.clientName !== null ? data.clientName : "NA"}
                </td>
                <td align="center">
                  {data.hrmsExpenseTypeDto &&
                    data.hrmsExpenseTypeDto.hrmsExpenseName}
                </td>
                <td align="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <span>
                      {/* {data
                        ? data.amount !== null
                          ? data.amount.toFixed(2)
                          : "NA"
                        : "NA"} */}
                      {data
                        ? data.appliedAmount !== null
                          ? data.appliedAmount.toFixed(2)
                          : "0.00"
                        : "0.00"}
                    </span>
                  </Box>
                </td>
                <td align="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <span>
                      {data.approvedAmount ? data.approvedAmount : "0.00"}
                    </span>
                  </Box>
                </td>
                <td align="center">
                  {data?.appliedAmount && data?.approvedAmount
                    ? (
                        data.appliedAmount.toFixed(2) - data.approvedAmount
                      ).toFixed(2)
                    : "0.00"}
                </td>
                <td align="center">
                  {data.remarks !== null && data.remarks !== ""
                    ? data.remarks
                    : "NA"}
                </td>
                <td align="center">
                  {data
                    ? data.expenseStatus && data.isAmountDeviation === true
                      ? `${data.expenseStatus} (Amount Deviated)`
                      : data.expenseStatus
                    : "NA"}
                </td>
                <td align="center">
                  {/* {data?.userFileExpenseDto
                    ?.map((item) => item.fileUrl)
                    .join(", ")} */}
                  {data?.userFileExpenseDto?.map((item) => (
                    <a href={item.fileUrl} key={item.fileUrl} target="_blank">
                      {item.fileUrl}
                    </a>
                  ))}
                </td>
              </tr>
            );
          })}
      </table>
    </>
  );
}

export default ExpenseExcel;
